module.exports = __webpack_public_path__ + "static/img/bg_item_4.736cafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_4.png
// module id = rByq
// module chunks = 1